import React from "react";
import RowActionsMenu, {
  RowActionsMenuItem,
} from "../Components/RowActionsMenu";

/**
 * Row-level overflow menu for the People directory.
 */
export default function PeopleRowActionsMenu({
  person,
  canEdit,
  onEditPerson,
}) {
  if (!canEdit) {
    return null;
  }

  return (
    <RowActionsMenu className="people-row-actions">
      <RowActionsMenuItem onSelect={() => onEditPerson?.(person)}>
        Edit
      </RowActionsMenuItem>
    </RowActionsMenu>
  );
}
